import { css } from 'styled-components';
import colors from './modules/core/constants/Colors';

export default {
  alert: {
    warning: {
      fontWeight: 300,
    },
  },
  button: {
    primary: {
      width: '100%',
      fontFamily: 'Metropolis',
      fontWeight: 500,
      backgroundColor: '#9000ff',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '312px',
    },
    outlined: {
      fontFamily: 'Metropolis',
      fontWight: 500,
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '312px',
      position: 'relative',
    },
  },
  input: {
    labelText: {
      fontWeight: 300,
      color: '#859099',
    },
    inputElement: {
      fontWeight: 300,
    },
    helperText: {
      fontWeight: 300,
      lineHeight: '16px',
      paddingTop: '8px',
      textAlign: 'left',
    },
    password: {
      icon: {
        color: colors.blueyGrey,
        cursor: 'pointer',
      },
    },
  },
  contentBox: {
    container: {
      paddingLeft: 0,
      ...css`
        &$self {
          padding-left: 0;
        }
        .content-details {
          display: block;
          margin-top: 8px;
          font-size: 10px;
          color: #180a33;
        }
      `,
    },
    label: {
      position: 'relative',
      top: '-6px',
      fontWeight: 300,
    },
    content: {
      fontWeight: 300,
    },
  },
  switch: {
    text: {
      fontWeight: 300,
      lineHeight: '16px',
      color: '#180a33',
      maxWidth: '320px',
    },

    controller: {
      color: colors.periwinkleStrong,
    },
  },
  checkbox: {
    label: {
      fontFamily: 'Metropolis',
      fontSize: '14px',
      lineHeight: '1.29',
      color: '#859099',
      fontWeight: '300',
      alignSelf: 'flex-start',
    },
  },
  radio: {
    button: {
      checked: {
        color: '#9000ff',
      },
    },
    label: {
      lineHeight: '22px',
    },
  },
  modal: {
    container: {
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      zIndex: '9999',
    },
    backdrop: {
      zIndex: '999',
    },
  },
  select: {
    default: {
      fontWeight: '300',
    },
    container: css`
      .react-select__single-value,
      .react-select__input input {
        font-weight: 300;

        .nc--add-new-option {
          margin: 0;
        }
      }
    `,
    option: {
      fontWeight: 300,
    },
    menuNotice: {
      fontWeight: 300,
      fontSize: '12px',
      color: '#859099',
      padding: '24px 0',
    },
  },
  textArea: {
    default: {
      container: {
        fontWeight: 300,
      },
      label: {
        fontSize: '12px',
      },
      placeholder: {
        fontWeight: 300,
      },
      input: {
        fontWeight: 300,
      },
    },
  },
  slider: {
    main: {
      color: '#9000ff',
    },
  },
  tooltip: {
    text: {
      margin: 0,
      fontWeight: 300,
    },
  },
};
